const CUSTOMIZATION_STEPS = [
  'addMorePaper',
  'addressing',
  'addressingPreview',
  'detailAssign',
  'detailBack',
  'detailFront',
  'detailInside',
  'details',
  'detailWrite',
  'envelope',
  'freeSamples',
  'front',
  'links',
  'recipients',
  'reviewPaper',
  'rsvp',
  'rsvpEnvelope',
  'share',
] as const;

export type CustomizationStep = (typeof CUSTOMIZATION_STEPS)[number];

export const isCustomizationStep = (step?: string): step is CustomizationStep => {
  return Boolean(step && CUSTOMIZATION_STEPS.includes(step as CustomizationStep));
};

/**
 * @deprecated use CustomizationStep type after converting to typescript.  OKAY to
 * keep using this in a JavaScript file where we can't verify strings are of the correct type.
 */
export const CUSTOMIZATION_STEP_MAP = {
  detailFront: 'detailFront',
  detailInside: 'detailInside',
  detailWrite: 'detailWrite',
  detailBack: 'detailBack',
  detailAssign: 'detailAssign',
  envelope: 'envelope',
  recipients: 'recipients',
  addressing: 'addressing',
  addressingPreview: 'addressingPreview',
  rsvp: 'rsvp',
  rsvpEnvelope: 'rsvpEnvelope',
  reviewPaper: 'reviewPaper',
  front: 'front',
  details: 'details',
  links: 'links',
  freeSamples: 'freeSamples',
  share: 'share',
  addMorePaper: 'addMorePaper',
} as const;

const ADDRESSING_STEPS = [
  CUSTOMIZATION_STEP_MAP.recipients,
  CUSTOMIZATION_STEP_MAP.addressing,
  CUSTOMIZATION_STEP_MAP.addressingPreview,
] as const;

export type CustomizationAddressingStep = (typeof ADDRESSING_STEPS)[number];
export const isCustomizationAddressingStep = (
  step?: string
): step is CustomizationAddressingStep => {
  return Boolean(step && ADDRESSING_STEPS.includes(step as CustomizationAddressingStep));
};

const STEPS_ALLOWING_MULTIPLES = [
  CUSTOMIZATION_STEP_MAP.detailFront,
  CUSTOMIZATION_STEP_MAP.detailBack,
  CUSTOMIZATION_STEP_MAP.detailInside,
  CUSTOMIZATION_STEP_MAP.detailWrite,
  CUSTOMIZATION_STEP_MAP.detailAssign,
  CUSTOMIZATION_STEP_MAP.front,
  CUSTOMIZATION_STEP_MAP.details,
  CUSTOMIZATION_STEP_MAP.freeSamples,
  CUSTOMIZATION_STEP_MAP.share,
] as const;

export type CustomizationStepAllowingMultiples = (typeof STEPS_ALLOWING_MULTIPLES)[number];
export const isCustomizationStepAllowingMultiples = (
  step?: string
): step is CustomizationStepAllowingMultiples => {
  return Boolean(
    step && STEPS_ALLOWING_MULTIPLES.includes(step as CustomizationStepAllowingMultiples)
  );
};

const STEPS_WITH_FOIL = [CUSTOMIZATION_STEP_MAP.rsvp, CUSTOMIZATION_STEP_MAP.detailFront] as const;

export type CustomizationStepWithFoil = (typeof STEPS_WITH_FOIL)[number];
export const isCustomizationStepWithFoil = (step?: string): step is CustomizationStepWithFoil => {
  return Boolean(step && STEPS_WITH_FOIL.includes(step as CustomizationStepWithFoil));
};

const STEPS_WITHOUT_MOBILE_EDITOR = [
  CUSTOMIZATION_STEP_MAP.recipients,
  CUSTOMIZATION_STEP_MAP.addressing,
  CUSTOMIZATION_STEP_MAP.reviewPaper,
  CUSTOMIZATION_STEP_MAP.detailInside,
  CUSTOMIZATION_STEP_MAP.detailWrite,
] as const;

export type CustomizationStepWithoutMobileEditor = (typeof STEPS_WITHOUT_MOBILE_EDITOR)[number];
export const isCustomizationStepWithoutMobileEditor = (
  step?: string
): step is CustomizationStepWithoutMobileEditor => {
  return Boolean(
    step && STEPS_WITHOUT_MOBILE_EDITOR.includes(step as CustomizationStepWithoutMobileEditor)
  );
};

const ENVELOPE_STEPS = [
  CUSTOMIZATION_STEP_MAP.envelope,
  CUSTOMIZATION_STEP_MAP.rsvpEnvelope,
] as const;

export type CustomizationEnvelopeStep = (typeof ENVELOPE_STEPS)[number];
export const isCustomizationEnvelopeStep = (step?: string): step is CustomizationEnvelopeStep => {
  return Boolean(step && ENVELOPE_STEPS.includes(step as CustomizationEnvelopeStep));
};
